<template>
    <dashboard-layout>
                <QuestionComponent :questionsData="questionsData"
                                   :meta="meta"
                                   :isEnd="isEnd"
                                   @fetchQuestions="fetchQuestions" v-if="questionsData.length > 0"  :type="'session'"/>
    </dashboard-layout>
</template>

<script>
import axios from "axios";
import { useToast } from "vue-toastification";
import DashboardLayout from "../../dashboard-layout.vue";
import QuestionComponent from "./QuestionComponent.vue";

const toast = useToast();

export default {
    components: { DashboardLayout, QuestionComponent },
    data() {
        return {
            questionsData: [],
            meta: {}
        };
    },
    created() {
        this.fetchQuestions();
    },
    methods: {
        isEnd(){
            return false;
        },
        fetchQuestions(page = 1) {
            const id = toast.info('Getting content...', {icon: 'fa-solid fa-download'});
            axios.get(`questions`,{
                params: {
                    'subscribe_id': this.$route?.params?.subscribe_id,
                    'session_id': this.$route?.params?.session_id,
                    'page': page
                }
            })
                .then(response => {
                    this.questionsData = response.data.data;
                    this.meta = response.data.meta;
                    toast.dismiss(id);
                }).catch(error => {
                toast.dismiss(id);
                toast.error(`Error: ${error.response ? error.response.data.message : 'An error occurred'}`);
            });
        }
    }
};
</script>

<style scoped>
/* Add any styles specific to the parent component here */
</style>
